import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { BaseTypography as r } from "../../../../common/components/BaseStyledComponents/BaseTypography.js";
import o from "@mui/joy/Typography";
import { CellWrapper as l, DayCellWrapper as m } from "./styled.js";
const i = ({ dayOfWeek: t2 }) => e(l, { children: e(r, { level: "body-xs", textColor: "text.tertiary", children: t2 }) }), n = ({ dayNumber: r2, isCurrentMonth: l2, date: i2 }) => e(m, { active: l2, error: 3 === r2, children: l2 ? e(o, { level: "title-sm", textColor: "text.tertiary", children: r2 }) : t(o, { level: "body-xs", textColor: "neutral.400", children: [r2, " ", i2.locale("uk").format("MMM")] }) });
export {
  l as CellWrapper,
  n as DayCellElement,
  m as DayCellWrapper,
  i as HeaderCellElement
};
//# sourceMappingURL=index.js.map
